import { Component, ElementRef, HostListener, inject, viewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';


@Component({
    selector: 'notifications-dropdown',
    imports: [
        RouterModule,
    ],
    host: {
        'animate.enter': 'fade-enter',
        'animate.leave': 'fade-leave',
        'style': '--fade-duration: 0.2s',
    },
    styles: [
        `
        :host {
            display: flex;
            flex-direction: column;
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            pointer-events: none;
            z-index: 1000;
        }
        .notifications-dropdown {
            pointer-events: auto;
            position: relative;
            align-self: end;
            top: 70px;
            right: 150px;
            width: 495px;
            height: 600px;
            background-color: white;
            border-radius: 4px;
            border: 1px solid rgba(0, 0, 0, 0.15);
            padding: 8px 14px 16px 14px;
        }
        @media screen and (max-width: 766px) {
            .notifications-dropdown {
                right: 0;
            }
        }
        @media (max-width: 512px) {
            .notifications-dropdown {
                width: 100%;
                height: calc(100% - 70px);
            }
        }
        `,
    ],
    template: `
        <div class="notifications-dropdown shadow" #dropdown>
            <router-outlet></router-outlet>
        </div>
    `,
})
export class NotificationsDropdownComponent {

    private router = inject(Router);

    private firstClick = true;

    private dropdownEl = viewChild.required<ElementRef>('dropdown');

    ngOnInit() {
        setTimeout(() => {
            this.firstClick = false;
        });
    }

    @HostListener('document:click', ['$event'])
    closeNotificationsOnOutsideClick(event: Event) {
        if (this.firstClick) {
            return;
        }
        if (!this.dropdownEl().nativeElement.contains(event.target)) {
            this.router.navigate([{ outlets: { notifications: null } }]);
        }
    }
}
